import React from "react";
import { Route, Routes } from "react-router-dom";
import NotFound from "pages/common/notFound";
import Room from "./room";
import Calendar from "./calendar";

function Meeting() {
  return (
    <Routes>
      <Route path="/calendar" element={<Calendar />} />
      <Route path="/room" element={<Room />} />
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}

export default Meeting;
